<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <b-card no-body class="mb-0 p-2 calls-table">

    <div>
      <div class="d-flex full-width mb-1 align-items-center">
        <p class="font-weight-bolder mb-0">Completed Calls</p>
        <div class="ui-spacer"></div>
        <b-button :class="{'disabled': reportLoading}" @click="createReport()">Download CSV</b-button>
      </div>

      <b-table
        :responsive="true"
        class="data-table"
        hover
        :items="calls"
        :current-page="currentPage"
        :per-page="-1"
        :fields="headers">
      </b-table>

      <b-row class="p-1">
        <b-col md="6" class="m-1" v-if="totalRows > limit">
          <b-pagination :total-rows="totalRows" :per-page="limit" v-model="currentPage" class="my-0"/>
        </b-col>
        <p v-if="totalRows === 0" class="col-6 ml-2 my-1">No Calls available</p>
      </b-row>
    </div>

<!--    <div v-else>Please select an establishment to see completed calls</div>-->


  </b-card>
</template>
<!-- eslint-enable -->

<script>
  import Papa from 'papaparse';
  // import moment from 'moment';
  import { mapState } from 'vuex';
  import BiStatsService from '../../../services/BiStatsService';
  import { getVisitBookedForDate } from '../../../util/helpers';

  export default {
    components: {},
    props: {
      filters: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        calls: [],
        headers: [
          { key: 'prisonNumber', label: 'Prisoner Number' },
          { key: 'prisonName', label: 'Prison' },
          { key: 'bookedFor', label: 'Booked For' },
        ],
        limit: 10,
        currentPage: 1,
        perPage: 10,
        totalRows: 10,
        selectedFeedback: null,
        reportCSV: [],
        reportCSVPage: 1,
        reportLoading: false,
      };
    },
    computed: {
      ...mapState({
        prisons: state => state.stats.prisons,
      }),
    },
    watch: {
      currentPage() {
        this.getCalls();
      },
      filters: {
        handler() {
          this.getCalls();
        },
        deep: true,
      },
    },
    mounted() {
      this.getCalls();
    },
    methods: {
      getCalls() {
        const filters = {
          ...this.filters,
          limit: this.limit,
          // sort: '-visit_date',
          status: 'Completed',
          skip: (this.currentPage - 1) * this.limit,
        }

        BiStatsService.getCallsPaginated(filters).then(res => {
          this.totalRows = res.data.count;
          this.formatCalls(res.data.data);
        }).catch(err => {
          console.log('error getting calls', err);
          this.$toast.error('Could not get completed calls, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      },
      formatCalls(calls) {
        this.calls = [];

        calls.forEach(item => {
          const bookedFor = getVisitBookedForDate(item);

          this.calls.push({
            bookedFor: bookedFor.bookedFor,
            ...item,
          });
        });
      },
      createReport() {
        this.reportLoading = true;
        this.reportCSVPage = 1; // set the first page to one
        this.reportCSV = []; // reset array

        this.getCallsForCSV();
      },
      getCallsForCSV() {
        const newFilters = { ...this.filters };
        newFilters.limit = 500;
        newFilters.skip = (this.reportCSVPage - 1) * newFilters.limit;
        newFilters.status = 'Completed';

        BiStatsService.getCallsPaginatedFullDetails(newFilters).then(res => {
          this.reportCSV = this.reportCSV.concat(res.data.data); // keep adding since were stacking requests

          if (this.reportCSV.length < res.data.count) {
            this.getMoreCallsForCSV();
          } else {
            this.generateReport();
          }
        });
      },
      getMoreCallsForCSV() {
        this.reportCSVPage += 1;
        this.getCallsForCSV();
      },
      generateReport() {
        const callsFormatted = this.reportCSV.map(fb => ({
            prisonNumber: fb.prisonNumber || '-',
            prisonName: fb.prisonName || '-',
            bookingSlotStartDateTime: fb.booked_slot ? fb.booked_slot.start_date_time : '-',
            hostname: fb.hostname || '-',
            appVersion: fb.appVersion || '-',
            // totalPauses: fb.totalPauses,
          }));

        this.exportReport(callsFormatted);
      },
      exportReport(feedbackFormatted) {
        const csv = Papa.unparse(feedbackFormatted);
        const hiddenElement = document.createElement('a');
        hiddenElement.href = `data:text/csv;charset=utf-8,${encodeURI(csv)}`;
        hiddenElement.target = '_blank';
        hiddenElement.download = `feedback-${this.filters.after}-${this.filters.before}.csv`;
        document.querySelector('#app').append(hiddenElement);
        hiddenElement.click();
        hiddenElement.remove();

        this.reportLoading = false;
      },
    },
  };
</script>
